import type { Messages } from "@/i18n/locales/en";
import { legalMessagesCs } from "@/i18n/locales/legalCsData";
import { pagesMessagesCs } from "@/i18n/locales/pagesCsData";

export const csMessages = {
  meta: {
    description:
      "WasOK — skenujte produkty, ukládejte hodnocení a poznámky, pamatujte si, co stálo za koupi.",
    title: "WasOK — Pamatujte si, co stálo za koupi",
  },
  header: {
    navFeatures: "Funkce",
    navHowItWorks: "Jak to funguje",
    navPrivacy: "Soukromí",
    navUseCases: "Použití",
    download: "Stáhnout",
    openMenu: "Otevřít menu",
    closeMenu: "Zavřít menu",
    languageAria: "Jazyk",
  },
  hero: {
    badge: "📱 Nyní dostupné na Androidu",
    title: "Pamatujte si, co stálo za koupi.",
    subtitle:
      "Skenujte produkty, ukládejte hodnocení a poznámky a okamžitě si vzpomeňte, zda byl produkt opravdu dobrý.",
    googlePlay: "Stáhnout z Google Play",
    watchDemo: "Zhlédnout demo",
    privacyLine: "Všechna data zůstávají ve vašem zařízení.",
    phoneTitle: "WasOK",
    phoneSubtitle: "Skenujte a pamatujte",
    snackCard: "Výborné!",
    coffeeCard: "Příliš hořká",
    scrollHint: "Posuňte se a prozkoumejte",
  },
  problems: {
    heading: "Zní to povědomě?",
    subheading:
      "Každý to zná — stát před regálem a snažit se vzpomenout, jestli to minule chutnalo.",
    notedAgo: "✓ Zaznamenali jste to před 3 měsíci",
    items: [
      {
        question: "Která čokoláda mi opravdu chutnala?",
        note: "Perfektní sladkost",
      },
      {
        question: "Proč jsem přestal kupovat tento šampon?",
        note: "Vysušoval mi vlasy",
      },
      {
        question: "Byla tato káva dobrá, nebo zklamání?",
        note: "Příliš hořká",
      },
    ],
  },
  howItWorks: {
    heading: "Jak to funguje",
    subheading:
      "Čtyři jednoduché kroky, abyste už nikdy nezapomněli své názory na produkty.",
    stepPrefix: "Krok",
    steps: [
      {
        title: "Naskenujte jakýkoli čárový kód produktu",
        description:
          "Rychlé a snadné skenování fotoaparátem. Funguje s jakýmkoli čárovým kódem.",
      },
      {
        title: "Uložte hodnocení, komentáře a fotografie",
        description:
          "Hodnoťte produkty, přidávejte poznámky, připojujte fotografie a zaznamenávejte ceny a místa.",
      },
      {
        title: "Okamžitě si vzpomeňte na svou zkušenost",
        description:
          "Později naskenujte stejný produkt a uvidíte své předchozí hodnocení a poznámky.",
      },
      {
        title: "Vytvářejte chytré nákupní seznamy",
        description:
          "Vytvářejte nákupní seznamy z produktů, kterým už důvěřujete a které máte rádi.",
      },
    ],
  },
  privacy: {
    heading: "Vaše nákupní historie zůstává vaše.",
    body: "WasOK vám pomáhá pamatovat si vyzkoušené produkty a zároveň uchovává hodnocení, poznámky, fotografie a nákupní seznamy lokálně ve vašem zařízení.",
    trustBanner:
      "💚 Postaveno kolem vaší nákupní historie — ne kolem shromažďování vašich dat.",
    bullets: [
      "Není vyžadován účet",
      "Není vyžadována cloudová synchronizace",
      "Lokální úložiště na prvním místě",
      "Zálohy pod vaší kontrolou",
      "Volitelné vyhledávání čárových kódů pro informace o produktech.",
      "Financováno reklamou přes Google AdMob",
    ],
  },
  features: {
    heading: "Vše, co potřebujete",
    subheading:
      "Výkonné funkce navržené tak, aby sledování produktů bylo jednoduché a soukromé.",
    items: [
      {
        title: "Skener čárových kódů",
        description: "Rychlé a přesné skenování čárových kódů jakéhokoli produktu.",
      },
      {
        title: "Hodnocení produktů",
        description: "Hodnoťte produkty 1–5 hvězdičkami a pamatujte si kvalitu.",
      },
      {
        title: "Fotografie produktů",
        description: "Připojujte fotografie a pamatujte si obaly nebo detaily.",
      },
      {
        title: "Kategorie",
        description: "Organizujte produkty do vlastních kategorií.",
      },
      {
        title: "Sledování obchodů",
        description: "Pamatujte si, kde jste každý produkt koupili.",
      },
      {
        title: "Záznam cen",
        description: "Sledujte ceny a najděte nejlepší nabídky.",
      },
      {
        title: "Nákupní seznamy",
        description: "Vytvářejte seznamy z oblíbených produktů.",
      },
      {
        title: "Offline přístup",
        description: "Funguje perfektně i bez internetového připojení.",
      },
      {
        title: "Lokální úložiště",
        description: "Všechna data jsou bezpečně uložena ve vašem zařízení.",
      },
    ],
  },
  useCases: {
    heading: "Ideální pro každou uličku",
    subheading:
      "Ať už nakupujete jídlo, kosmetiku nebo domácí potřeby — WasOK vám pomůže pamatovat.",
    cards: [
      {
        emoji: "🍫",
        title: "Pamlsky a sladkosti",
        description: "Pamatujte si, které cukrovinky byly opravdu dobré.",
      },
      {
        emoji: "☕",
        title: "Káva a nápoje",
        description: "Sledujte kávy, které stojí za další koupi.",
      },
      {
        emoji: "💄",
        title: "Kosmetika a péče o pleť",
        description: "Vedte si poznámky o reakcích pokožky.",
      },
      {
        emoji: "🧹",
        title: "Domácí potřeby",
        description: "Vyhněte se opětovnému nákupu produktů, které zklamaly.",
      },
    ],
  },
  screenshots: {
    heading: "Krásné a intuitivní",
    subheading:
      "Promyšleně navržené rozhraní, které dělá sledování produktů radostí.",
    items: [
      { title: "Skener" },
      { title: "Detail produktu" },
      { title: "Zadání hodnocení" },
      { title: "Hledání a historie" },
      { title: "Nákupní seznam" },
    ],
  },
  cta: {
    heading: "Nákupní paměť pro skutečný život.",
    body: "Přestaňte zapomínat, které produkty stály za koupi. Začněte nakupovat chytřeji ještě dnes.",
    googlePlay: "Stáhnout z Google Play",
    scanQr: "Naskenujte a stáhněte",
    tagline: "Soukromé · Offline na prvním místě · Jednoduché",
  },
  footer: {
    tagline: "Pamatujte si, co stálo za koupi.",
    linksHeading: "Odkazy",
    privacyPolicy: "Zásady ochrany osobních údajů",
    terms: "Podmínky služby",
    contact: "Kontakt",
    linkFaq: "FAQ",
    linkLicenses: "Open-source licence",
    linkAdvertising: "Reklama a monetizace",
    downloadHeading: "Stáhnout",
    googlePlay: "Google Play",
    copyright:
      "© 2026 WasOK. Všechna práva vyhrazena. Vytvořeno s 💚 pro chytřejší nakupování.",
  },
  legal: legalMessagesCs,
  faq: pagesMessagesCs.faq,
  support: pagesMessagesCs.support,
  advertising: pagesMessagesCs.advertising,
} satisfies Messages;
